export const asRigSite = {
  data: `<svg width="10" height="12" viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 0.666504H10V11.3332H8V0.666504ZM0 7.33317H2V11.3332H0V7.33317ZM4 3.99984H6V11.3332H4V3.99984Z"/>
  </svg>
  `,
  name: 'rigsite',
};
